import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, toDisplayString as _toDisplayString, withModifiers as _withModifiers, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  id: "login-container",
  class: "min-h-screen flex items-center justify-center p-4 bg-gray-100"
}
const _hoisted_2 = {
  id: "login-card",
  class: "bg-white border border-gray-600/20 rounded-2xl w-full max-w-lg p-8 bg-gray-50"
}
const _hoisted_3 = {
  key: 0,
  class: "mb-6 flex items-start space-x-3 bg-amber-50 border border-amber-200 text-amber-800 rounded-md px-4 py-3 text-sm"
}
const _hoisted_4 = {
  id: "email-field",
  class: "space-y-2"
}
const _hoisted_5 = { class: "relative" }
const _hoisted_6 = {
  id: "password-field",
  class: "space-y-2"
}
const _hoisted_7 = { class: "relative" }
const _hoisted_8 = ["disabled"]
const _hoisted_9 = {
  key: 0,
  class: "fa-solid fa-sign-in-alt mr-2"
}
const _hoisted_10 = {
  key: 1,
  class: "fa-solid fa-circle-notch fa-spin mr-2"
}

import { useAuthStore } from '@/store/auth';
import { useNotificationStore } from '@/store/notifications';
import { ref, computed } from 'vue';
import { useRouter, useRoute } from 'vue-router';


export default /*@__PURE__*/_defineComponent({
  __name: 'login',
  setup(__props) {

const emailAddress = ref('');
const password = ref('');
const loading = ref(false);
const error = ref('');
const success = ref(false);
const router = useRouter();
const route = useRoute();
const authStore = useAuthStore();
const notificationStore = useNotificationStore();

const sessionExpired = computed(() => route.query.expired === 'true');

async function handleLogin() {
  error.value = '';
  success.value = false;

  if (!emailAddress.value || !password.value) {
    notificationStore.showError('Validation Error', 'Please enter both email address and password.');
    return;
  }

  loading.value = true;
  try {
    await authStore.login(emailAddress.value, password.value);

    if (authStore.error) {
      notificationStore.showError('Login Failed', authStore.error);
    } else {
      notificationStore.showSuccess('Login Successful', 'Welcome back! Redirecting...');
      const redirectPath = sessionStorage.getItem('redirectPath') || '/dashboard';
      sessionStorage.removeItem('redirectPath');
      setTimeout(() => {
        router.push(redirectPath);
      }, 1500);
    }
  } catch (err) {
    notificationStore.showError('Login Error', 'An unexpected error occurred during login.');
  } finally {
    loading.value = false;
  }
}

function togglePassword() {
  const passwordInput = document.getElementById('password') as HTMLInputElement;
  const toggleIcon = document.getElementById('password-toggle');

  if (passwordInput && toggleIcon) {
    if (passwordInput.type === 'password') {
      passwordInput.type = 'text';
      toggleIcon.classList.remove('fa-eye');
      toggleIcon.classList.add('fa-eye-slash');
    } else {
      passwordInput.type = 'password';
      toggleIcon.classList.remove('fa-eye-slash');
      toggleIcon.classList.add('fa-eye');
    }
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[10] || (_cache[10] = _createStaticVNode("<div id=\"logo-section\" class=\"text-center mb-8\"><div class=\"inline-flex items-center justify-center h-16 mb-4\"><h3 class=\"bg-brand text-2xl text-center text-green-800\"><i class=\"fa-solid fa-fingerprint text-green-800 font-bold\"></i> ether<span class=\"font-bold\">.id</span></h3></div><p class=\"text-gray-300 text-sm\">Login Into Your Account</p></div>", 1)),
      (sessionExpired.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, _cache[3] || (_cache[3] = [
            _createElementVNode("i", { class: "fa-solid fa-clock-rotate-left mt-0.5 flex-shrink-0" }, null, -1),
            _createElementVNode("span", null, "Your session has expired. Please sign in again to continue.", -1)
          ])))
        : _createCommentVNode("", true),
      _createElementVNode("form", {
        id: "login-form",
        class: "space-y-6",
        onSubmit: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (handleLogin()), ["prevent"]))
      }, [
        _createElementVNode("div", _hoisted_4, [
          _cache[5] || (_cache[5] = _createElementVNode("label", {
            for: "email",
            class: "block text-sm font-medium text-gray-600"
          }, "Email Address", -1)),
          _createElementVNode("div", _hoisted_5, [
            _cache[4] || (_cache[4] = _createElementVNode("div", { class: "absolute inset-y-0 left-0 pl-3 flex items-center justify-center pointer-events-none" }, [
              _createElementVNode("i", { class: "fa-solid fa-envelope text-green-600 leading-none" })
            ], -1)),
            _withDirectives(_createElementVNode("input", {
              type: "email",
              id: "email",
              name: "email",
              class: "block w-full pl-10 pr-3 py-3 bg-white/10 border border-gray-500/20 rounded-md border-gray-300 text-gray-600 placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-green-500 focus:border-transparent",
              placeholder: "john@example.com",
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((emailAddress).value = $event)),
              required: ""
            }, null, 512), [
              [_vModelText, emailAddress.value]
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_6, [
          _cache[8] || (_cache[8] = _createElementVNode("label", {
            for: "password",
            class: "block text-sm font-medium text-gray-600"
          }, "Password", -1)),
          _createElementVNode("div", _hoisted_7, [
            _cache[7] || (_cache[7] = _createElementVNode("div", { class: "absolute inset-y-0 left-0 pl-3 flex items-center justify-center pointer-events-none" }, [
              _createElementVNode("i", { class: "fa-solid fa-lock text-green-600 leading-none" })
            ], -1)),
            _withDirectives(_createElementVNode("input", {
              type: "password",
              id: "password",
              name: "password",
              class: "block w-full pl-10 pr-12 py-3 bg-white/10 border border-gray-500/20 rounded-md text-gray-600 placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-green-500 focus:border-transparent",
              placeholder: "••••••••••",
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((password).value = $event)),
              required: ""
            }, null, 512), [
              [_vModelText, password.value]
            ]),
            _createElementVNode("div", { class: "absolute inset-y-0 right-0 pr-3 flex items-center" }, [
              _createElementVNode("button", {
                type: "button",
                class: "text-gray-400 hover:text-gray-300",
                onClick: togglePassword
              }, _cache[6] || (_cache[6] = [
                _createElementVNode("i", {
                  id: "password-toggle",
                  class: "fa-solid fa-eye"
                }, null, -1)
              ]))
            ])
          ])
        ]),
        _cache[9] || (_cache[9] = _createStaticVNode("<div id=\"remember-section\" class=\"flex items-center justify-between\"><div class=\"flex items-center\"><input id=\"remember-me\" name=\"remember-me\" type=\"checkbox\" class=\"h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300 rounded bg-white/10 border-white/20\"><label for=\"remember-me\" class=\"ml-2 block text-sm text-gray-300\"> Remember me </label></div><div class=\"text-sm\"><span class=\"text-blue-400 hover:text-blue-300 transition-colors cursor-pointer\"> Forgot password? </span></div></div>", 1)),
        _createElementVNode("button", {
          type: "submit",
          id: "login-button",
          disabled: loading.value,
          class: "w-full flex justify-center items-center py-3 px-4 border border-transparent rounded-sm shadow-sm text-sm font-medium text-white bg-gradient-to-r from-green-700 to-green-800 hover:from-green-700 hover:to-green-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 transition-all duration-200 transform hover:scale-[1.02] disabled:opacity-70 disabled:cursor-not-allowed disabled:transform-none"
        }, [
          (!loading.value)
            ? (_openBlock(), _createElementBlock("i", _hoisted_9))
            : (_openBlock(), _createElementBlock("i", _hoisted_10)),
          _createTextVNode(" " + _toDisplayString(loading.value ? 'Signing in...' : 'Sign In to Dashboard'), 1)
        ], 8, _hoisted_8)
      ], 32),
      _cache[11] || (_cache[11] = _createStaticVNode("<div id=\"security-info\" class=\"mt-8 pt-6 border-t border-white/20\"><div class=\"flex items-center justify-center space-x-4 text-sm text-gray-400\"><div class=\"flex items-center\"><i class=\"fa-solid fa-shield-check mr-2 text-green-400\"></i><span>Secure Login</span></div><div class=\"flex items-center\"><i class=\"fa-solid fa-key mr-2 text-blue-400\"></i><span>2FA Protected</span></div></div></div><div id=\"footer-links\" class=\"mt-6 text-center text-xs text-gray-500\"><p>© 2025 EtherOne Africa. All rights reserved.</p><div class=\"mt-2 space-x-4\"><span class=\"hover:text-gray-400 transition-colors cursor-pointer\">Privacy Policy</span><span>•</span><span class=\"hover:text-gray-400 transition-colors cursor-pointer\">Terms of Service</span><span>•</span><span class=\"hover:text-gray-400 transition-colors cursor-pointer\">Support</span></div><img src=\"/assets/images/logo/logo.png\" width=\"100\" class=\"w-60 mx-auto p-4\" alt=\"EtherID Logo\"></div>", 2))
    ])
  ]))
}
}

})